/**
 * Template Generator Utility
 * Generates downloadable XLSX template with column headers
 */
import * as XLSX from "xlsx";
/**
 * Template column definitions matching the PerfectServe Resident Roster Template.
 * This drives the "Download Template" feature. The import side is flexible and
 * accepts many header variations via COLUMN_MAPPINGS.
 */
export const TEMPLATE_COLUMNS = [
    // Required fields
    { header: "Last Name", field: "lastName", required: true },
    { header: "First Name", field: "firstName", required: true },
    { header: "NPI Number", field: "npi", required: false },
    { header: "Active Directory (AD) / (UPN), if applicable", field: "username", required: false },
    { header: "Credentials", field: "credentials", required: false },
    { header: "Specialty", field: "specialty", required: false },
    { header: "Email Address", field: "email", required: true },
    { header: "Mobile Number (Please enter with no hyphens)", field: "mobileNumber", required: false },
    { header: "Pager Number, if applicable (Please enter with no hyphens)", field: "pagerNumber", required: false },
    { header: "Pager Carrier", field: "pagerCarrier", required: false },
    { header: "Qgenda/AMiOn ID, if applicable", field: "integrationMappings", required: false },
    { header: "Effective Date", field: "effectiveDate", required: false },
    { header: "Copy User - (For PS Internal Use Only)", field: "copyUserId", required: true },
];
/**
 * Generate an XLSX template file with headers only
 * @returns Blob containing the XLSX file
 */
export function generateTemplateBlob() {
    // Create workbook
    const workbook = XLSX.utils.book_new();
    // Create header row only
    const headers = TEMPLATE_COLUMNS.map((col) => col.header);
    const wsData = [headers];
    // Create worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(wsData);
    // Set column widths for better readability
    const colWidths = TEMPLATE_COLUMNS.map((col) => ({
        wch: Math.max(col.header.length + 2, 15),
    }));
    worksheet["!cols"] = colWidths;
    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "User Provisioning");
    // Generate buffer
    const buffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    // Create and return blob
    return new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
}
/**
 * Generate and download the XLSX template
 * @param filename - Optional filename
 */
export function downloadTemplate(filename) {
    const blob = generateTemplateBlob();
    const finalFilename = filename || "UserProvisioning_Template.xlsx";
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = finalFilename;
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
/**
 * Get the list of required columns
 */
export function getRequiredColumns() {
    return TEMPLATE_COLUMNS.filter((col) => col.required);
}
/**
 * Get the list of optional columns
 */
export function getOptionalColumns() {
    return TEMPLATE_COLUMNS.filter((col) => !col.required);
}
